// extracted by mini-css-extract-plugin
export var fulfillmentPanel = "_fw-0";
export var fulfillmentPanelBody = "_fw-1";